export default {
  activeModal: null,
  target: null,

  get isOpen () {
    return this.activeModal !== null
  },

  isActive (name) {
    return this.activeModal === name
  },

  open (name, target = null) {
    this.activeModal = name
    this.target = target
  },

  close () {
    this.activeModal = null
  }
}
